// controllers/expiration_controller.js
import { Controller } from "@hotwired/stimulus"

export default class ExpirationTimerController extends Controller {
  static targets = ["counter", "label"]
  static values = {
    expiresAt: Number,
    warnSeconds: { type: Number, default: 300 },
  }

  connect() {
    this.update = this.update.bind(this)
    this.warned = false

    this.update()
    this.timer = setInterval(this.update, 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
  const endMs = this.expiresAtValue
  if (!endMs) { this.counterTarget.textContent = "--:--"; return }

  const diffMs = endMs - Date.now()

    if (diffMs <= 0) {
      this.counterTarget.textContent = "00:00"
      this.dispatch("expired")
      clearInterval(this.timer)
      this.timer = null
      return
    }

    const totalSeconds = Math.floor(diffMs / 1000)

    if (totalSeconds < this.warnSecondsValue && !this.warned) {
      this.warned = true
      this.counterTarget.classList.add("text-amber-400")

      // optional label swap
      if (this.hasLabelTarget) {
        this.labelTarget.textContent = "Rate expires soon"
      }

      this.dispatch("warning")
    }

    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    this.counterTarget.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }

  handleExpired() {
    if (document.querySelector('[data-controller~="deposit-success"]')) {
      return
    }
    // Redirect to expired page when countdown reaches 00:00
    Turbo.visit("/deposit/crypto/expired", { action: "replace" })
  }
}
